import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseCircleFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	id: "svg1",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs1" }), /* @__PURE__ */ _jsx("path", {
		id: "path2",
		d: "m 12,2.25 c -5.3851246,0 -9.75,4.3648754 -9.75,9.75 0,5.384095 4.3648154,9.75 9.75,9.75 5.385195,0 9.75,-4.365905 9.75,-9.75 C 21.75,6.6148754 17.385095,2.25 12,2.25 Z M 9.6601563,8.9160156 c 0.1919435,0 0.3828867,0.072305 0.5292967,0.21875 L 11.992188,10.9375 13.794922,9.1367188 c 0.2929,-0.2928898 0.767647,-0.2928898 1.060547,0 0.292899,0.2928997 0.292899,0.7676471 0,1.0605472 l -1.802735,1.800781 1.808594,1.806641 c 0.2929,0.292899 0.2929,0.767647 0,1.060546 -0.2929,0.2929 -0.767747,0.2929 -1.060547,0 l -1.808593,-1.80664 -1.800782,1.800781 c -0.2928095,0.2929 -0.7676569,0.2929 -1.0605466,0 -0.2928997,-0.2929 -0.2928997,-0.767647 0,-1.060547 L 10.931641,11.998047 9.1289063,10.195313 c -0.2928998,-0.2929202 -0.2928998,-0.7676577 0,-1.0605474 0.1464448,-0.1464448 0.3393064,-0.21875 0.53125,-0.21875 z"
	})]
});
export default SvgCloseCircleFill;
